import type {
  LiksChatComposerExclusiveAction,
  LiksChatComposerExclusiveLockLabels,
} from './LiksChatComposer.types';

export function resolveExclusiveAction(options: {
  hasAttachments: boolean;
  hasLinkedKnowledgeBases: boolean;
  webSearchEnabled: boolean;
  imageGenerationEnabled: boolean;
}): LiksChatComposerExclusiveAction | null {
  if (options.hasAttachments) {
    return 'attachments';
  }
  if (options.hasLinkedKnowledgeBases) {
    return 'knowledge';
  }
  if (options.webSearchEnabled) {
    return 'webSearch';
  }
  if (options.imageGenerationEnabled) {
    return 'imageGeneration';
  }
  return null;
}

export function resolveExclusiveLockTooltip(
  target: LiksChatComposerExclusiveAction,
  exclusiveAction: LiksChatComposerExclusiveAction | null,
  labels: LiksChatComposerExclusiveLockLabels,
): string | undefined {
  if (exclusiveAction == null || exclusiveAction === target) {
    return undefined;
  }

  if (target === 'attachments') {
    if (exclusiveAction === 'knowledge') {
      return labels.attach.becauseKnowledge;
    }
    if (exclusiveAction === 'webSearch') {
      return labels.attach.becauseWebSearch;
    }
    return labels.attach.becauseImageGeneration;
  }

  if (target === 'knowledge') {
    if (exclusiveAction === 'attachments') {
      return labels.knowledge.becauseAttachments;
    }
    if (exclusiveAction === 'webSearch') {
      return labels.knowledge.becauseWebSearch;
    }
    return labels.knowledge.becauseImageGeneration;
  }

  if (target === 'webSearch') {
    if (exclusiveAction === 'attachments') {
      return labels.webSearch.becauseAttachments;
    }
    if (exclusiveAction === 'knowledge') {
      return labels.webSearch.becauseKnowledge;
    }
    return labels.webSearch.becauseImageGeneration;
  }

  if (exclusiveAction === 'attachments') {
    return labels.imageGeneration.becauseAttachments;
  }
  if (exclusiveAction === 'knowledge') {
    return labels.imageGeneration.becauseKnowledge;
  }
  return labels.imageGeneration.becauseWebSearch;
}
